<template>
    <div id="mysidebar" class="w-11/12">
        <div class="flex justify-center card-background">
            <vs-card class="xl:w-full shadow-lg custom-height px-4">
                <!-- <div class="">
                    <vx-action-icon :icon="$vs.rtl ? 'ArrowRightIcon' : 'ArrowLeftIcon'" @click="navBack"> </vx-action-icon>
                    <h3 class="inline-block ml-5">Create Coupon</h3>
                </div> -->
                <action-bar class="action-bar">
                    <template v-slot:left class="w-full">
                        <vx-action-icon
                            :icon="$vs.rtl ? 'ArrowRightIcon' : 'ArrowLeftIcon'"
                            @click="navBack"
                        >
                        </vx-action-icon>
                        <h2 class="ml-5">{{ details.id ? 'Edit Coupon' : 'Create Coupon' }}</h2>
                    </template>
                </action-bar>

                <form ref="form" @submit.prevent="validate" class="">
                    <div class="w-full">
                        <div class="w-6/12 ml-2 mr-2">
                            <p class="w-3/12">Coupon Type</p>
                            <ul class="flex w-9/12 mt-1">
                                <li>
                                    <vs-radio
                                        color="#95dbb7"
                                        v-model="details.couponTypeId"
                                        vs-value="1"
                                        :disabled="couponID"
                                        >Corporate</vs-radio
                                    >
                                </li>
                                <li class="ml-5">
                                    <vs-radio
                                        color="#95dbb7"
                                        v-model="details.couponTypeId"
                                        vs-value="2"
                                        :disabled="couponID"
                                    >
                                        Discount
                                    </vs-radio>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="flex justify-evenly mt-5 px-2">
                        <div class="w-6/12">
                            <vx-select
                                label="Product"
                                name="product"
                                placeholder="Choose a Product"
                                v-validate="'required'"
                                class="w-full mt-2"
                                v-model="selectedProduct"
                                :options="products"
                                idKey="id"
                                textKey="name"
                            >
                            </vx-select>
                            <span class="text-danger text-sm" v-show="errors.has('product')">{{
                                errors.first('product')
                            }}</span>

                            <vs-input
                                label="Coupon Code"
                                v-validate="'required'"
                                name="coupon code"
                                v-model="details.code"
                                class="w-full mt-2"
                                placeholder="Enter coupon code"
                            />
                            <span class="text-danger text-sm" v-show="errors.has('coupon code')">{{
                                errors.first('coupon code')
                            }}</span>

                            <vx-calendar-input
                                label="Coupon valid until"
                                class="w-full mt-2"
                                v-model="details.couponExpiry"
                            ></vx-calendar-input>

                            <vs-input
                                label="Number of Coupons"
                                v-validate="'required|min_value:1'"
                                name="Number of coupons"
                                type="number"
                                class="w-full mt-2"
                                v-model="details.qty"
                            />
                            <span
                                class="text-danger text-sm"
                                v-show="errors.has('Number of coupons')"
                                >{{ errors.first('Number of coupons') }}</span
                            >
                            <vx-textarea
                                label="Coupon description (Internal)"
                                v-model="details.description"
                                rows="3"
                                class="w-full mt-3"
                                placeholder="Enter coupon description"
                            ></vx-textarea>
                            <vx-textarea
                                label="Coupon message (Displayed to customer)"
                                v-model="details.message"
                                rows="3"
                                class="w-full -mt-1"
                                placeholder="Enter coupon message"
                            ></vx-textarea>
                        </div>

                        <div class="w-6/12 px-2">
                            <!-- <transition name="slide-in"> -->
                            <div v-if="details.couponTypeId == 1">
                                <div class="flex mt-2">
                                    <vs-input
                                        label="Access duration (Months free)"
                                        type="number"
                                        min="1"
                                        color="#95dbb7"
                                        class="w-full"
                                        v-model="details.accessDuration"
                                    />
                                </div>

                                <div class="w-full mt-2">
                                    <vs-input
                                        label="Logo of company"
                                        type="file"
                                        class="w-full"
                                        v-model="details.logoData"
                                    ></vs-input>
                                </div>
                            </div>
                            <!-- </transition>
                            <transition name="slide-in"> -->
                            <div v-if="details.couponTypeId == 2">
                                <div class="flex mt-2">
                                    <vs-input
                                        label="Discount percent"
                                        type="number"
                                        min="1"
                                        class="w-full"
                                        v-model="details.discount"
                                    />
                                </div>
                            </div>
                            <!-- </transition> -->
                        </div>
                    </div>

                    <div class="flex justify-center mt-10 relative">
                        <button type="submit" class="create w-1/6 h-12 z-50">
                            {{ couponID ? 'Save' : 'Create' }}
                        </button>
                    </div>
                </form>
            </vs-card>
        </div>
    </div>
</template>

<script>
import ActionBar from '@/components/custom/ActionBar'
import { mapParams } from '@/plugins/mappers'

export default {
    name: 'create-coupon',
    components: {
        ActionBar
    },
    computed: {
        ...mapParams({
            url_id: 'coupon_id'
        }),
        couponID() {
            return this.url_id
        }
    },
    props: {},
    data() {
        return {
            loading: false,
            products: [],
            selectedProduct: null,
            details: {
                code: null,
                description: null,
                message: null,
                couponTypeId: 1,
                accessDuration: null,
                qty: 0,
                qtyUsed: 0,
                discount: 0,
                logoName: null,
                logoData: null,
                couponExpiry: new Date(),
                productId: null
            }
        }
    },
    methods: {
        validate() {
            this.loading = true
            this.$validator.validateAll().then(async (result) => {
                if (result) {
                    try {
                        var response
                        if (this.details.id) {
                            //todo:update
                            response = await this.$api.coupon.updateCoupon(this.details)
                            // console.log('Updated')
                            this.notifySuccess(
                                'Updated successfully',
                                'Coupon Updated successfully.',
                                5000
                            )
                        } else {
                            //create
                            response = await this.$api.coupon.createCoupon(this.details)
                            // console.log('Created!', response)
                            this.notifySuccess(
                                'Created successfully',
                                'Coupon created successfully.',
                                5000
                            )
                            this.$router.replace(`/coupons/${response.id}`)
                        }
                    } catch (err) {
                        console.error(err)
                        this.notifyError('Error', `Error message: ${err}`, 5000)
                    } finally {
                        this.loading = false
                    }
                }
            })
            this.loading = false
        },
        navBack() {
            this.$router.go(-1)
        },
        async getDetails() {
            if (this.couponID) {
                this.loading = true
                try {
                    this.details = await this.$api.coupon.fetchCoupon(this.couponID)
                    this.details.couponExpiry = new Date(this.details.couponExpiry)
                    this.selectedProduct = { id: this.details.productId }
                    // console.log(this.details)
                } catch (err) {
                    console.error(err)
                    this.notifyError(
                        'Communication Error',
                        'Could not retrieve coupon details from server, please check your connection and try again.',
                        5000
                    )
                } finally {
                    this.loading = false
                }
            }
        }
    },
    watch: {
        couponID: {
            handler: async function (coupon_id) {
                if (coupon_id) {
                    await this.getDetails()
                }
            },
            immediate: true
        },
        selectedProduct: {
            handler: function (val) {
                this.details.productId = val.id
            }
        }
    },
    async mounted() {
        var response = await this.$api.product.fetchProducts({
            search: null,
            sortKey: null,
            sortType: null,
            pageSize: null,
            pageNo: 1
        })
        this.products = response.data
    }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Barlow:wght@300;400;500;600;700;800&family=Playfair+Display:wght@400;500;600;700;800&display=swap');
.croc {
    position: absolute;
    left: 10px;
    bottom: -25px;
}
.card-background {
    background: transparent;
    height: 100%;
}
.custom-height {
    min-height: 600px;
}
.create {
    border: none;
    border-radius: 50px;
    background-color: #9dd6cd;
    color: #fff;
    font-size: 1.5rem;
    box-shadow: 0px 2px 6px 0.5px #bebebe;
    cursor: pointer;
    font-family: 'Playfair Display', serif;
    letter-spacing: 2px;
}
a {
    font-size: 1rem;
}
p {
    color: #949c9c;
}
li {
    color: #949c9c;
    font-size: 1.1rem;
}

.slide-in-enter-active {
    transition: all 0.7s ease;
    box-shadow: 0px 0px 10px 4px #9dd6cd;
}
.slide-in-leave-active {
    transition: all 0.7s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-in-enter,
.slide-in-leave-to {
    /* transform: translateX(10px); */
    opacity: 0;
}
</style>
